const reducer = (state = '', action) =>{
    switch(action.type){
        case "setConsortiumId": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  